import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 14,
	viewBox: "0 0 21 14",
	fill: "white",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.66667 0.333496C0.746192 0.333496 0 1.07969 0 2.00016V12.1668C0 13.0873 0.746193 13.8335 1.66667 13.8335H11.8333C12.7538 13.8335 13.5 13.0873 13.5 12.1668V2.00016C13.5 1.07969 12.7538 0.333496 11.8333 0.333496H1.66667ZM15.3661 4.59287C15.1416 4.70627 15 4.9364 15 5.18795V8.81206C15 9.0636 15.1416 9.29373 15.3661 9.40713L19.5328 11.5115C19.9762 11.7355 20.5 11.4132 20.5 10.9164V3.08357C20.5 2.5868 19.9762 2.26454 19.5328 2.48849L15.3661 4.59287Z",
		fill: "current"
	})]
});
const ForwardRef = forwardRef(SvgVideo);
export { ForwardRef as ReactComponent };
